import { MIN_VIG, MAX_VIG, MIN_EDGE, MAX_EDGE } from '@pff-consumer/schema'

export const getSelectedSecondaryFiltersCount = (
  gameIds: string[],
  matchups: string[],
  edgeFilters: string[],
  vigFilters: string[]
) => {
  const edgeSliderAdjusted = Number(edgeFilters[0]) === MIN_EDGE && Number(edgeFilters[1]) === MAX_EDGE ? 0 : 1
  const vigSliderAdjusted = Number(vigFilters[0]) === MIN_VIG && Number(vigFilters[1]) === MAX_VIG ? 0 : 1
  const selectedFiltersCount = gameIds.length + matchups.length + vigSliderAdjusted + edgeSliderAdjusted
  return selectedFiltersCount
}
